<template>
  <!-- ご契約者情報 -->
  <div class="l-main-content">
    <div class="p-team-subscription">
      <div class="c-title">
        <div class="c-title__text">ご契約者の情報</div>
        <div class="c-text">
          <a href="#config-subscription">ご契約情報を変更する</a>
        </div>
      </div>
      <div class="p-team-subscription__data">
        <dl class="p-team-subscription-list">
          <dt class="p-team-subscription-list__label">ご契約者さま</dt>
          <dd class="p-team-subscription-list__value">{{ contractData.name }}（{{ contractData.mail }}）</dd>
          <dt class="p-team-subscription-list__label">ご契約内容</dt>
          <dd class="p-team-subscription-list__value">
            <ul class="p-team-subscription-list-detail">
              <li v-for="(element, loopIndex1) in contractData.elements" :key="loopIndex1" class="p-team-subscription-list-detail__item">{{ element }}</li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
  </div>
<!-- /ご契約者情報 -->
</template>

<script>
export default {
  props: {
    contractData: Object,
  },
}
</script>
